// Add styles, because we have our own for search and cannot use RUP.
import '../../../../skins/RFE/RUP/patterns/_search.scss';
import '../../../../skins/RFE/Common/Search/GlobalSearch.scss';
import '../../../../skins/RFE/jqueryui.css';
import '../../styles/jqueryui-override.scss';
// We need to import this file because it contains specific instructions
// for registering the Global search control within the RFE namespace. To avoid duplicating this registration logic,
// we should import the entire module using the line below.
import '../../../../scripts/common/SearchControls/GlobalSearch/GlobalSearch';
// Once the class is actually used in this file, we can remove the line above.
// The line below imports the GlobalSearch class from the source file.
// However, this class is not actually used within this file, it is only used for type definitions.
// Therefore, this file will not be imported during the compilation process because of the optimization.
// eslint-disable-next-line no-duplicate-imports
import GlobalSearch from '../../../../scripts/common/SearchControls/GlobalSearch/GlobalSearch';
import { GlobalSearchMode, MultiSearch } from '../../../../scripts/common/SearchControls/GlobalSearch/typings';
import React from 'react';

export interface IGlobalSearchHandlersWrapper {
	executeSearch?: (control: GlobalSearch) => void;
	sideItemChanged?: (control: GlobalSearch, value: MultiSearch) => void;
	advancedSearch?: (control: GlobalSearch) => void;
	clearResult?: (control: GlobalSearch) => void;
}

export interface IGlobalSearchProps {
	handlers: IGlobalSearchHandlersWrapper;
	searchMode?: GlobalSearchMode;
	testId?: string;
}

const GlobalSearchWrapper: React.FunctionComponent<IGlobalSearchProps> = props => {
	const locatorRef = React.useRef<HTMLDivElement | null>(null);
	const globalSearchInstance = React.useRef<GlobalSearch | null>(null);

	React.useEffect(() => {
		if (locatorRef.current) {
			const control = document.getElementById('GlobalSearch');
			if (control) {
				locatorRef.current.appendChild(control);
				globalSearchInstance.current = Sys.Application.findComponent('GlobalSearch') as GlobalSearch;
				setHandlersFromWrapper(globalSearchInstance.current, props.handlers);
				if (props.searchMode) {
					globalSearchInstance.current.setSearchMode(props.searchMode);
				}
			}
		}
	}, []);

	React.useEffect(() => {
		if (globalSearchInstance.current && props.searchMode) {
			globalSearchInstance.current.setSearchMode(props.searchMode);
		}
	}, [props.searchMode]);

	React.useEffect(() => {
		if (globalSearchInstance.current) {
			setHandlersFromWrapper(globalSearchInstance.current, props.handlers);
		}
	}, [props.handlers]);

	return <div data-test-id={props.testId ?? 'global-search'} ref={locatorRef}></div>;
};

const setHandlersFromWrapper = (globalSearch: GlobalSearch, handlers: IGlobalSearchHandlersWrapper) => {
	globalSearch.setEventHandlers({
		executeSearch: handlers.executeSearch ? () => handlers.executeSearch(globalSearch) : emptyHandler,
		sideItemChanged: handlers.sideItemChanged
			? (value: MultiSearch) => handlers.sideItemChanged(globalSearch, value)
			: emptyHandler,
		advancedSearch: handlers.advancedSearch ? () => handlers.advancedSearch(globalSearch) : emptyHandler,
		clearResult: handlers.clearResult ? () => handlers.clearResult(globalSearch) : emptyHandler
	});
};

// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyHandler = () => {};

export default GlobalSearchWrapper;
